if ( typeof ProductQuantity !== 'function' ) {

	class ProductQuantity extends HTMLElement {

		constructor(){

			super();

			const qty = this.querySelector('.qty-selector'),
						qtyMinus = this.querySelector('.qty-minus'),
						qtyPlus = this.querySelector('.qty-plus');

			const getMinMax = () => ({
				min: qty.getAttribute('min') ? parseInt(qty.getAttribute('min'), 10) : 1,
				max: qty.getAttribute('max') ? parseInt(qty.getAttribute('max'), 10) : 999
			});

			const updateButtons = () => {
				const { min, max } = getMinMax();
				const val = parseInt(qty.value, 10) || min;
				qtyMinus.classList.toggle('disabled', val <= min);
				qtyPlus.classList.toggle('disabled', val >= max);
			};

			updateButtons();

			qty.addEventListener('change', (e)=>{
				const { min, max } = getMinMax();
				let currentQty = parseInt(qty.value, 10);
				if ( isNaN(currentQty) || currentQty < min ) currentQty = min;
				if ( currentQty > max ) currentQty = max;
				qty.value = currentQty;
				updateButtons();
			});

			qty.addEventListener('input', (e)=>{
				const { max } = getMinMax();
				const raw = parseInt(qty.value, 10);
				if ( ! isNaN(raw) && raw > max ) {
					qty.value = max;
					updateButtons();
				}
			});

			qtyMinus.addEventListener('click', (e)=>{
				e.preventDefault();
				const { min, max } = getMinMax();
				if ( ! qtyMinus.classList.contains('disabled') ) {
					const currentQty = parseInt(qty.value, 10);
					if ( currentQty - 1 >= min ) {
						qty.value = currentQty - 1;
						updateButtons();
					}
				}
			});

			qtyPlus.addEventListener('click', (e)=>{
				e.preventDefault();
				const { min, max } = getMinMax();
				if ( ! qtyPlus.classList.contains('disabled') ) {
					const currentQty = parseInt(qty.value, 10);
					if ( currentQty + 1 <= max ) {
						qty.value = currentQty + 1;
						updateButtons();
					}
				}
			});

		}
		
	}


  if ( typeof customElements.get('product-quantity') == 'undefined' ) {
    customElements.define('product-quantity', ProductQuantity);
	}

}